import decode from 'jwt-decode';

export default class AuthService {
  loggedIn() {
    const token = this.getToken();
    return !!token && !this.isTokenExpired(token);
  }

  isTokenExpired(token) {
    try {
      const decoded = decode(token);
      if (decoded.exp < Date.now() / 1000) {
        this.logout();
        return true;
      } else return false;
    } catch (err) {
      return false;
    }
  }

  setToken(idToken) {
    localStorage.setItem('landpoint-token', idToken);
  }

  getToken() {
    return localStorage.getItem('landpoint-token');
  }

  logout() {
    localStorage.removeItem('landpoint-token');
  }

  getProfile() {
    return decode(this.getToken());
  }
}
